import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Typography } from '@material-ui/core';
import _ from 'lodash';
import VoterData from './VoterData';
import VoterDataAutocomplete from './voting/VoterDataAutocomplete';

const VoterIdentificationMethods = ({ voterIdentificationMethods, change, voterIdentificationMethodId, actions, voterData, manualVote, autocomplete, customMessages, budgetId, requiresParentalConsent, parentalConsentAgeLimit, disabled }) => {
  const verificationMethod = voterIdentificationMethods.find(v => v.id === voterIdentificationMethodId);

  const updateIdentificationMethod = (e, id) => {
    change('voterIdentificationMethodId', id);

    const identificationMethod = voterIdentificationMethods.find(i => i.id === id);
    const voter = {};

    if (identificationMethod.voterRequiredData.address) {
      if (!identificationMethod.terytEnabled
        && !identificationMethod.streetsAutocomplete
        && identificationMethod.voterRequiredData.addressRestrictedToCities
        && identificationMethod.voterRequiredData.addressRestrictedToCities.length === 1) {
        voter.city = identificationMethod.voterRequiredData.addressRestrictedToCities[0];
      } else if (!identificationMethod.terytEnabled
        && identificationMethod.streetsAutocomplete
        && identificationMethod.voterRequiredData.addressRestrictedToCities
        && identificationMethod.voterRequiredData.addressRestrictedToCities.length === 1) {
        const data = _.uniqBy(identificationMethod.streetsAutocompleteData, s => s.cityId);
        const city = data.find(c => c.cityName === identificationMethod.voterRequiredData.addressRestrictedToCities[0]);
        if (city) {
          voter.city = city.cityName;
          voter.cityId = city.cityId;
        }
      }
    }

    change('voter', voter);
    e.preventDefault();
  };

  return (
    <React.Fragment>
      {voterIdentificationMethods.length > 1
        ? <React.Fragment>
            <Typography variant="subtitle2" component="p" gutterBottom>Wybierz metodę weryfikacji danych</Typography>
            <div className="row" style={{ justifyContent: 'center', marginTop: 16 }}>
              {voterIdentificationMethods.map(method => (
                <a key={method.id} href="#" onClick={e => updateIdentificationMethod(e, method.id)} className="col-sm-6 col-md-4 obszar-link">
                  <div className="inner-wrapper" style={{ borderWidth: voterIdentificationMethodId === method.id ? 2 : 0, borderStyle: 'solid', borderColor: 'black'}}>
                    <p>{method.name}</p>
                    <span className="btn">Wybierz</span>
                  </div>
                </a>
              ))}
            </div>
        </React.Fragment> : null}
      {verificationMethod ?
          <React.Fragment>
            <VoterData
              voterRequiredData={verificationMethod.voterRequiredData || {}}
              streetsAutocomplete={verificationMethod.streetsAutocomplete}
              streetsAutocompleteData={verificationMethod.streetsAutocompleteData}
              terytEnabled={verificationMethod.integrationType === 'radix' || verificationMethod.terytEnabled}
              terytFilter={verificationMethod.terytFilter}
              phoneVerificationEnabled={verificationMethod.phoneVerificationEnabled}
              change={change}
              actions={actions}
              values={voterData}
              verificationMethodId={verificationMethod.id}
              manualVote={manualVote}
              customMessages={customMessages}
              budgetId={budgetId}
              requiresParentalConsent={requiresParentalConsent}
              parentalConsentAgeLimit={parentalConsentAgeLimit}
              disabled={disabled}
            />
            {autocomplete && verificationMethod.votersDataAutocomplete ?
              <VoterDataAutocomplete
                voterRequiredData={verificationMethod.voterRequiredData || {}}
                onSuggestVoters={data => actions.suggestVoters(data, verificationMethod.id)}
                values={voterData}
                change={change}
                streetsAutocompleteData={verificationMethod.streetsAutocompleteData}
              /> : null}
            </React.Fragment>
          : null}
      <Field
        name="voterIdentificationMethodId"
        component={({ meta }) => (meta.error && meta.touched ? <Typography variant="caption" color="error" component="p" style={{ marginTop: 16 }}>{meta.error}</Typography> : null)}
      />
    </React.Fragment>
  );
};

VoterIdentificationMethods.propTypes = {
  voterIdentificationMethods: PropTypes.array.isRequired,
  change: PropTypes.func.isRequired,
  voterIdentificationMethodId: PropTypes.string,
  voterData: PropTypes.object,
  actions: PropTypes.object.isRequired,
  manualVote: PropTypes.bool,
  autocomplete: PropTypes.bool,
  customMessages: PropTypes.object.isRequired,
  budgetId: PropTypes.string,
  requiresParentalConsent: PropTypes.bool,
  parentalConsentAgeLimit: PropTypes.number,
  disabled: PropTypes.bool,
};

export default VoterIdentificationMethods;



// WEBPACK FOOTER //
// ./src/components/budget/VoterIdentificationMethods.js